import { LoaderFunctionArgs } from "react-router"
import { Poap } from "../../domain/poap/Models/Poap"

export type PoapDetailLoaderData = { poap: Poap }

export const poapDetailLoader = async ({ params }: LoaderFunctionArgs) => {
  const poap = await window.domain.GetPoapByIdUseCase.execute({ id: params.id! }).catch(console.error)
  if (!poap) throw new Error("Poap not found")
  return { poap } satisfies PoapDetailLoaderData
}
